export const categoryContent = [
	{
		name: 'Civic Engagement',
		description: "I'm part of the “Cordées de la Réussite” program, which helps high school students from disadvantaged backgrounds discover the engineering professions.",
		button: "More",
		link: '/',
		id: '1ed'
	},
	{
		name: 'My Projects',
		description: 'From simple interfaces to complex web interfaces, during my two years at ENSEEIHT I had the opportunity to work on a bunch of different computer science projects.',
		button: 'View all my projects',
		link: '/projects',
		id: '1ed'
	},
	{
		name: 'My Education',
		description: 'Getting to ENSEEIHT requires a particular academic background, I did the classic one, you can acces all the details here.',
		button: 'Details',
		link: '/education',
		id: '2ed'
	}	
]